// 誘導モーダルプレビュー: 親ウィンドウからの postMessage を受信し、
// モーダル内の DOM 要素を data-preview-target で特定して書き換える。
//
// 親 → iframe へ送られるメッセージ形式:
//   {
//     type: 'guidance_modal:update',
//     payload: {
//       heading?: string,
//       message?: string,
//       action_label?: string,
//       link_url?: string,
//       image_url?: string | null,
//     }
//   }
//
// scenario_type / menu_url_name / category_url_name の切替は
// iframe.src の更新（reload）で対応するため、ここでは扱わない。

export const initGuidanceModalPreviewListener = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const modalEl = document.getElementById('guidance_modal');
    if (!modalEl) return;
    if (modalEl.dataset.isPreview !== 'true') return;

    window.addEventListener('message', (event) => {
      // 同一オリジンのみ許可（iframe 親と origin が一致することを担保）
      if (event.origin !== window.location.origin) return;

      const data = event.data;
      if (!data || data.type !== 'guidance_modal:update') return;

      const payload = data.payload || {};
      applyUpdate(modalEl, payload);
    });

    // 親ウィンドウに ready 通知（初期化完了を伝えて親側の初回 postMessage を促す）
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(
        { type: 'guidance_modal:ready' },
        window.location.origin,
      );
    }
  });
};

const applyUpdate = (modalEl, payload) => {
  if (typeof payload.heading === 'string') {
    setText(modalEl, 'heading', payload.heading);
  }
  if (typeof payload.message === 'string') {
    setText(modalEl, 'message', payload.message);
  }
  if (typeof payload.action_label === 'string') {
    setText(modalEl, 'action-label', payload.action_label);
  }
  if (typeof payload.link_url === 'string') {
    const link = modalEl.querySelector('[data-preview-target="link"]');
    if (link) link.setAttribute('href', payload.link_url);
  }
  if ('image_url' in payload) {
    updateImage(modalEl, payload.image_url);
  }
};

const setText = (root, target, value) => {
  // 投稿シナリオの submit ボタンは input[type="submit"] で、テキストは value 属性で表示される。
  // それ以外の要素は textContent を更新する。data-preview-target は重複し得るので全件処理。
  root.querySelectorAll(`[data-preview-target="${target}"]`).forEach((el) => {
    if (el.tagName === 'INPUT' && el.type === 'submit') {
      el.value = value;
    } else {
      el.textContent = value;
    }
  });
};

const updateImage = (modalEl, imageUrl) => {
  const wrapper = modalEl.querySelector(
    '[data-preview-target="image-wrapper"]',
  );
  const img = modalEl.querySelector('[data-preview-target="image"]');
  if (!wrapper || !img) return;

  if (imageUrl) {
    img.setAttribute('src', imageUrl);
    wrapper.style.display = '';
  } else {
    img.removeAttribute('src');
    wrapper.style.display = 'none';
  }
};
